{% block sw_extension_store_index %}
    <sw-iframe-renderer
        v-if="storeUrl"
        class="sw-extension-store-iframe"
        :src="storeUrl"
        location-id=""
    />

    <sw-extension-store-purchase-confirmation-modal />
{% endblock %}
